(() => {
  const lockedButtonSelector = '[data-add-to-cart][data-release-locked="true"], #sticky-add-to-cart-button[data-release-locked="true"]';

  const lockButton = (button) => {
    if (!button.disabled) button.disabled = true;
    if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
  };

  const enforceReleaseLocks = (root = document) => {
    if (root instanceof Element && root.matches(lockedButtonSelector)) lockButton(root);
    root.querySelectorAll(lockedButtonSelector).forEach(lockButton);
  };

  enforceReleaseLocks();

  document.addEventListener('product:variant-change', () => {
    window.requestAnimationFrame(() => enforceReleaseLocks());
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(lockedButtonSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.target.querySelector('[data-add-to-cart][data-release-locked="true"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const observer = new MutationObserver((mutations) => {
    // Inspect newly inserted content, not the full storefront for every app update.
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) enforceReleaseLocks(node);
    }));
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
